export default class Planboard {
  constructor(planboard, $elm) {
    this.$elm = $elm
    this.planboard = planboard
    this.$confirmButton = this.$elm.find('[data-planboard-action="planner.submit"]')
    this.$updateButton = this.$elm.find('[data-button-type="update-booking"]')
  }

  show() {
    this.$elm.addClass('active')
  }

  hide() {
    this.$elm.removeClass('active')
  }

  book() {
    const $activeSelector = $('.planboard__package-selector.active')
    const $selectedSlots = $activeSelector.find('[data-selected-slot][data-needs-to-be-scheduled]')
    $selectedSlots.each(function(index, elm) {
      var $elm = $(elm)
      var $input = $elm.find('input[type=hidden]')
      $input.val(
        JSON.stringify({
          id: $elm.attr('data-selected-slot'),
          productKey: $elm.attr('data-product-key'),
          productGroupKey: $elm.attr('data-product-group-key'),
          productGroupName: $elm.attr('data-product-group-name'),
          productGroupProductKey: $elm.attr('data-product-group-product-key'),
          productGroupProductQuantity: $elm.attr('data-product-group-product-quantity'),
          dealId: $elm.attr('data-deal'),
        }),
      )
    })
    this.$elm.submit()
  }

  update() {
    console.log('Planner.update()')
    let valid = true
    // Check the new slots
    this.$elm.find('input[name="slot[]"]').each(function(index, elm) {
      if (elm.value == '') {
        valid = false
      }
    })
    // Check the existing slots
    this.$elm.find('input[name="needs-to-be-scheduled[]"]').each(function(_, elem) {
      valid = elem.value === '1' ? false : valid
    })
    this.$confirmButton.prop('disabled', !valid)
    this.$updateButton.prop('disabled', !valid)
    this.setNonScheduledInputData()
    this.setParallelProductsInputData()
  }

  setNonScheduledInputData() {
    this.$elm.find('[data-duration="0"]').each(function(index, extrasRow) {
      const $extrasRow = $(extrasRow)
      const $input = $extrasRow.find('input[type=hidden][name="extrasslots[]"]')
      if ($input && $input.length > 0) {
        const planObject = {
          productKey: $extrasRow.attr('data-product-key'),
          productGroupKey: $extrasRow.attr('data-product-group-key'),
          productGroupProductKey: $extrasRow.attr('data-product-group-product-key'),
          productGroupProductQuantity: $extrasRow.attr('data-product-group-product-quantity'),
          dealId: $extrasRow.attr('data-deal'),
        }
        $input.val(JSON.stringify(planObject))
      }
    })
  }
  setParallelProductsInputData() {
    this.$elm.find('[data-parallel-product-no-needs-to-be-scheduled="1"]').each(function(index, extrasRow) {
      const $extrasRow = $(extrasRow)
      const $input = $extrasRow.find('input[type=hidden][name="slot[]"]')
      if ($input && $input.length > 0) {
        const planObject = {
          id: `${$extrasRow.attr('data-activity-key')}|2020-01-01T00:00:00Z`,
          productKey: $extrasRow.attr('data-product-key'),
          productGroupKey: $extrasRow.attr('data-product-group-key'),
          productGroupProductKey: $extrasRow.attr('data-product-group-product-key'),
          productGroupName: $extrasRow.attr('data-product-group-name'),
          productGroupProductQuantity: $extrasRow.attr('data-product-group-product-quantity'),
          dealId: $extrasRow.attr('data-deal'),
        }
        $input.val(JSON.stringify(planObject))
      }
    })
  }
}
